import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';
import { HotelEventsViewModel } from '@api/v3';

const MobileEvents = dynamic(() => import('./MobileEvents'));
const DesktopEvents = dynamic(() => import('./DesktopEvents'));

type Props = {
  events: HotelEventsViewModel[];
};

const HotelDetailEvents = ({ events }: Props) => {
  const { isDesktop } = useDevice();

  return isDesktop ? (
    <DesktopEvents events={events} />
  ) : (
    <MobileEvents events={events} />
  );
};

export default HotelDetailEvents;
